import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

interface ILabel {
  medium?: boolean;
}

export const Label = styled.div<ILabel>`
  font-size: 14px;
  color: #000;
  font-weight: ${({ medium }) => (medium ? '500' : '400')};
  flex: 1;
`;

export const Icon = styled.img`
  margin-top: 3px;
`;
